/** An Enumeration of all available icons */
export enum IconType {
  ARROW = 'arrow',
  BURGERMENU = 'burgermenu',
  CAMERA = 'camera',
  CAR = 'car',
  CARD = 'card',
  CARET_DOWN = 'caret_down',
  CARET_LEFT = 'caret_left',
  CARET_RIGHT = 'caret_right',
  CARET_UP = 'caret_up',
  CHECK = 'check',
  CLOCK = 'clock',
  COMPUTER = 'computer',
  CROSS = 'cross',
  DANGER = 'danger',
  DATE = 'date',
  EDIT = 'edit',
  EDIT_BASIC = 'edit_basic',
  ENVELOPE = 'envelope',
  EXIT = 'exit',
  EXTERNALLINK = 'externallink',
  EYE = 'eye',
  FILE = 'file',
  HANDSHAKE = 'handshake',
  HOME = 'home',
  INFO = 'info',
  LANGUAGE = 'language',
  LIGHTBULB = 'lightbulb',
  LINK = 'link',
  LIST = 'list',
  LOADING = 'loading',
  LOCK = 'lock',
  MAP = 'map',
  MARKER = 'marker',
  PACK = 'pack',
  PAINT_BRUSH = 'paint_brush',
  PHONE = 'phone',
  PHOTO = 'photo',
  PLUS = 'plus',
  PROFILE = 'profile',
  QUESTION = 'question',
  REFRESH = 'refresh',
  SALARY = 'salary',
  SELL_OUTLINE = 'sell_outline',
  STAR = 'star',
  STAR_EMPTY = 'star_empty',
  STOPWATCH = 'stopwatch',
  THREEDOTS = 'threedots',
  TRASH = 'trash',
  TRIANGLE = 'triangle',
}

/** An Enumeration of all available icon colors */
export enum ColorClass {
  BLACK = 'black',
  WHITE = 'white',
  GRAY = 'gray',
  RED = 'secondary-red-dark',
  PRIMARY_ORANGE = 'primary-orange',
  PRIMARY_BLUE = 'primary-blue',
  PRIMARY_GREEN = 'primary-green',
  PRIMARY_RED = 'primary-red',
  SECONDARY_ORANGE_DARK = 'secondary-orange-dark',
  SECONDARY_BLUE_DARK = 'secondary-blue-dark',
  SECONDARY_GREEN_DARK = 'secondary-green-dark',
  SECONDARY_ORANGE_LIGHT = 'secondary-orange-light',
  SECONDARY_BLUE_LIGHT = 'secondary-blue-light',
  SECONDARY_GREEN_LIGHT = 'secondary-green-light',
  SECONDARY_RED_LIGHT = 'secondary-red-light',
}
